document.addEventListener('DOMContentLoaded', function () {
    fetch('https://api.country.is')
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Network error');
            }
            return response.json();
        })
        .then(function (location) {
            var url = '';
            switch (location.country) {
                case 'DE':
                case 'AT':
                    url = 'attiluskaviar.de';
                    break;
                case 'FR':
                    url = 'attiluskaviar.fr';
                    break;
                case 'NL':
                    url = 'attiluskaviar.nl';
                    break;
                case 'ES':
                    url = 'attiluscaviar.es';
                    break;
                case 'DK':
                case 'DA':
                    url = 'attiluskaviar.dk';
                    break;
                case 'SE':
                case 'SV':
                    url = 'attiluscaviar.se';
                    break;
                case 'BE':
                    url = 'attiluscaviar.be';
                    break;
                case 'LU':
                    url = 'attiluscaviar.lu';
                    break;
                case 'IT':
                    url = 'attiluscaviar.it';
                    break;
                case 'FI':
                    url = 'attiluskaviar.fi';
                    break;
                case 'IE':
                    url = 'attiluscaviar.ie';
                    break;
                case 'BG':
                case 'HR':
                case 'CY':
                case 'CZ':
                case 'EE':
                case 'GR':
                case 'HU':
                case 'LV':
                case 'LT':
                case 'MT':
                case 'PL':
                case 'PT':
                case 'RO':
                case 'SK':
                case 'SI':
                    url = 'attiluskaviar.com';
                    break;
            }

            var domain = window.location.hostname;

            if (url && domain.indexOf(url) === -1) {
                window.location.replace('https://www.' + url + window.location.pathname + window.location.search);
            }
        })
        .catch(function (error) {
            console.error('Geolocation error:', error);
        });
});